"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPassword = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconPassword = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M1.694 19.457v-2.15h20.524v2.15H1.694Zm1.292-6.161L1.53 12.45l.808-1.421H.698V9.336h1.64L1.53 7.94l1.456-.846.808 1.396.832-1.396 1.456.846-.808 1.396H6.89v1.693H5.274l.808 1.42-1.456.847-.832-1.446-.808 1.446Zm8.15.025-1.456-.846.808-1.421H8.872V9.36h1.616L9.68 7.965l1.456-.846.808 1.396.832-1.396 1.456.846-.808 1.396h1.616v1.693h-1.616l.808 1.42-1.456.847-.832-1.446-.808 1.446Zm8.15 0-1.456-.846.808-1.421h-1.616V9.36h1.616l-.808-1.396 1.456-.846.832 1.396.808-1.396 1.456.846-.808 1.396h1.64v1.693h-1.64l.808 1.42-1.456.847-.807-1.446-.833 1.446Z"
}));
exports.IconPassword = IconPassword;
//# sourceMappingURL=IconPassword.js.map